import React, { useState } from 'react';
import { useAuth } from '../App';
import { authService, extractErrorDetails } from '../services/api';
import ErrorDisplay from './ErrorDisplay';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [errorTrace, setErrorTrace] = useState(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setErrorTrace(null);
    setLoading(true);

    try {
      const response = await authService.login(username, password);
      if (response.success) {
        login(response.data);
      } else {
        setError(response.message || 'Error al iniciar sesión');
        setErrorTrace(response.errorTrace || null);
      }
    } catch (err) {
      const { message, errorTrace: trace } = extractErrorDetails(err, 'Error de conexión con el servidor');
      setError(message);
      setErrorTrace(trace);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>5 Esquinas</h2>
        <p className="subtitle">Sistema de Logística</p>
        
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="username">Usuario</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ingrese su usuario"
              required
            />
          </div>
          
          <div className="input-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingrese su contraseña"
              required
            />
          </div>
          
          <ErrorDisplay error={error} errorTrace={errorTrace} />
          
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Ingresando...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div style={{ marginTop: '24px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px', fontSize: '12px' }}>
          <p style={{ fontWeight: '500', marginBottom: '8px' }}>Usuarios de prueba:</p>
          <p>• <strong>deposito</strong> / deposito123 (Admin Depósito)</p>
          <p>• <strong>supermercado</strong> / super123 (Admin Supermercado)</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
